// extracted by mini-css-extract-plugin
module.exports = {"RowItem":"Summery_RowItem__sbj2n","Summery":"Summery_Summery__3ZIRb","Seprator":"Summery_Seprator__28QfW","TitleAmount":"Summery_TitleAmount__2-IHs"};